import { useLocation } from "react-router-dom";

/**
 * Where a capture screen's ✕ (close) should return to. Entry hubs (Dashboard / Library) pass
 * `state={{ from }}` on their "create" links; the ✕ reads it so you go back to where you started.
 * Falls back to the dashboard when there is no origin (e.g. a direct deep-link).
 */
export function useCloseTo(fallback = "/dashboard"): string {
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from;
  return from ?? fallback;
}
